import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const DashboardNamesSkeleton = () => {
  return (
    <div>
      {" "}
      <div style={{ display: "flex", gap: "1rem", background:"white", borderRadius:"50px" }}>
        <div
          className="skeleton"
          style={{ width: "100px", height: "38px",borderRadius:"50px",marginBottom:"0px" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "100px", height: "38px",borderRadius:"50px",marginBottom:"0px"  }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "100px", height: "38px",borderRadius:"50px",marginBottom:"0px"  }}
        ></div>
      </div>
    </div>
  );
};
